import React from "react";
import { ErrorNotification } from "store/errors/types";
import { getBrowser } from "utils";

interface RequestPermissionsProps {
  error?: ErrorNotification;
}

export const RequestPermissions: React.FC<RequestPermissionsProps> = ({
  error,
}) => {
  return (
    <>
      {error ? (
        <PermissionsErrorText browser={getBrowser().name} />
      ) : (
        <p className="lead text-center">
          For others to see and hear you, your browser needs access to your
          camera and microphone.
        </p>
      )}
    </>
  );
};

const PermissionsErrorText: React.FC<{ browser?: string }> = ({ browser }) => {
  return (function () {
    switch (browser) {
      case "Firefox":
        return (
          <>
            <p className="lead text-center">
              It looks like you've blocked this site from accessing your camera
              and microphone. In order to enable them:
            </p>
            <ul>
              <li>
                <strong>Click the icon</strong> on the left side of the address
                bar.
              </li>
              <li>
                Under <strong>Permissions</strong>, remove{" "}
                <strong>Blocked</strong> or <strong>Blocked Temporarily</strong>{" "}
                for Camera and Microphone.
              </li>
              <li>
                Click <strong>Request Permissions</strong>.
              </li>
            </ul>
          </>
        );
      case "Safari":
        return (
          <>
            <p className="lead text-center">
              It looks like you've blocked this site from accessing your camera
              and microphone. In order to enable them:
            </p>
            <ul>
              <li>
                <strong>Click the icon</strong> on the left side of the address
                bar.
              </li>
              <li>
                Click <strong>Website Settings</strong>.
              </li>
              <li>
                Change the <strong>Camera</strong> and{" "}
                <strong>Microphone</strong> settings from <strong>Deny</strong>{" "}
                to <strong>Allow</strong> or <strong>Ask</strong>.
              </li>
              <li>
                Finally, click <strong>Request Permissions</strong>.
              </li>
            </ul>
          </>
        );
      case "Chrome":
      default:
        return (
          <>
            <p className="lead text-center">
              It looks like you've blocked this site from accessing your camera
              and microphone. In order to enable them:
            </p>
            <ul>
              <li>
                <strong>Click the icon</strong> on the left side of the address
                bar.
              </li>
              <li>
                Change the <strong>Camera</strong> and{" "}
                <strong>Microphone</strong> settings from <strong>Block</strong>{" "}
                to <strong>Allow</strong>.
              </li>
              <li>
                Click <strong>Request Permissions</strong>.
              </li>
            </ul>
          </>
        );
    }
  })();
};
